import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './testimonials.slider.less';

const defaultSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
  autoplaySpeed: 5000,
};

export const TestimonialsSlider = ({ settings, testimonials }) => {
  const nSettings = { ...defaultSettings, ...settings };
  return (
    <Slider {...nSettings}>
      {testimonials.map((testemonie) => {
        const {
          title, subtitle, name, position,
        } = testemonie;
        return (
          <Fragment key={`${name}_${position}`}>
            {title && <div className="m-testimonials__title">{title}</div>}
            {subtitle && <div className="m-testimonials__subtitle">{subtitle}</div>}
            {name && <div className="m-testimonials__name">{name}</div>}
            {position && <div className="m-testimonials__position">{position}</div>}
          </Fragment>
        );
      })}
    </Slider>
  );
};

TestimonialsSlider.propTypes = {
  settings: PropTypes.shape({}),
  testimonials: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

TestimonialsSlider.defaultProps = {
  settings: defaultSettings,
};

export default TestimonialsSlider;
